import React, { useEffect, useState } from "react";
import axios from "axios";
import { dashboardURL } from "../../Config/Url";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import Card from "react-bootstrap/Card";
import SpinnerLoading from "../Common/SpinnerLoading";

const LastAddedTenant = () => {
  const [lastAddedTenant, setLastAddedTenant] = useState([]);
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  let config = {
    headers: {
      "X-IsMockup": false,
    },
  };

  useEffect(() => {
    axios
      .get(`${dashboardURL}/last-added-tenant`, config)
      .then((result) => {
        setLastAddedTenant({
          name: result.data.name,
          street: result.data.street,
          city: result.data.city,
          dateAdded: format(new Date(result.data.dateAdded), "dd. MM. yyyy."),
        });
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
  }, []);

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <>
          <Card.Body className="dashboard-card-body-tenant">
            <div className="dashboard-card-body-tenant-part1">
              {/* <Card.Img variant="left" src={tenantIcon} /> */}
              <span
                className="icon icon-tile-view"
                style={{ fontSize: 85 }}
              ></span>
              <div className="dashboard-card-body-tenant-complexData">
                <span className="dashboard-card-body-tenant-data-name">
                  {lastAddedTenant.name.length >= 15
                    ? `${lastAddedTenant.name.substring(0, 15)}...`
                    : lastAddedTenant.name}
                </span>
                <span className="dashboard-card-body-tenant-data-location">
                  {lastAddedTenant.street.length >= 20
                    ? `${lastAddedTenant.street.substring(0, 20)}...`
                    : lastAddedTenant.street}

                  <br />
                  {lastAddedTenant.city}
                </span>
              </div>
            </div>
            <div className="dashboard-card-body-tenant-part2">
              {lastAddedTenant.dateAdded}
            </div>
          </Card.Body>
          <Card.Footer className="dashboard-card-footer-tenant">
            {translator("Dashboard-LastAddedTenant-Title")}
          </Card.Footer>
        </>
      )}
    </>
  );
};

export default LastAddedTenant;
